import { render } from "./AUKSSComponent.vue?vue&type=template&id=f6a40996"
import script from "./AUKSSComponent.vue?vue&type=script&lang=js"
export * from "./AUKSSComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__